<template>
  <ark-lb-tabs-item
    :class="[chosenPeriod === tabKey ? 'ark-active' : '', 'ark-leaderboard-tabs-item']"
    @click="onChoseTab"
    :ark-test-id='testId'
  >
    {{tabName}}
  </ark-lb-tabs-item>
</template>

<script>
  export default {
    props: ['tabKey', 'tabName', 'chosenPeriod', 'choseTab'],
    data () {
      return {
        testId: 'leaderboard-' + this.tabKey + '-btn',
        leaderboardData: null
      }
    },
    methods: {
      onChoseTab: function () {
        this.choseTab(this.tabKey)
      }
    }
  }
</script>

<style lang="scss" src="./TabsItem.scss"></style>



// WEBPACK FOOTER //
// TabsItem.vue?43db0c3c